import React, { useCallback, useState } from "react";
import ClientService from "../../../services/ClientService";
import TableContext, { TableContextValues } from "../../task/TableContext";
import {
  calculatePageCount,
  setCurrentPageHelper,
  sortHelper,
  useEndpointData
} from "../../../utils/TableUtils";
import { Cast } from "../../../utils/Utils";
import { ClientGroupRequest } from "../entities/ClientGroupRequest";
import FilterService from "../../../services/FilterService";

export class ReportClientGroupTableContextValues extends TableContextValues<
  any,
  { extraFilters: string[]; pagesize: any }
> {
  request: ClientGroupRequest = new ClientGroupRequest();
  setRequest: (request: ClientGroupRequest) => void = () => {};
}

const ReportClientGroupProvider = ({
  children,
  prevRequest = undefined
}: React.PropsWithChildren<{ prevRequest?: ClientGroupRequest }>) => {
  const [request, setRequest] = useState<ClientGroupRequest>(
    prevRequest ?? new ClientGroupRequest()
  );
  const endpoint = useCallback(() => {
    if (request.id === 0) {
      return Promise.resolve(
        Cast<ReturnType<typeof ClientService.getGroupReport>>(undefined)
      );
    }
    return ClientService.getGroupReport(request);
  }, [request]);
  const { loading, error, response, reload } = useEndpointData(endpoint);
  const pageCount = calculatePageCount(response);
  const { sort, setSortColumn } = sortHelper(request, setRequest);
  const applySearch = (keyword: any) => {
    setRequest({ ...request, text: keyword });
  };

  const value: ReportClientGroupTableContextValues = {
    loading,
    error,
    response,
    setSortColumn,
    currentPage: request.page,
    setCurrentPage: setCurrentPageHelper(setRequest, pageCount),
    pageCount: pageCount,
    applyFilters: (filters: { extraFilters: string[] }) =>
      setRequest((x) => ({
        ...x,
        filter:
          FilterService.GetExtraFiltersRequestString(filters.extraFilters) ?? ""
      })),
    applySearch,
    reload,
    sort,
    pageSize: request.pageSize,
    // setPageSize: setPageSizeHelper(setRequest),
    request,
    setRequest
  };

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
};

export default ReportClientGroupProvider;
